/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getDocByIdADM(DocId, ClientId, token) {
  const apiUrl = `${API_BASE_URL}/admin/document/list/byid`;

  const params = {
    "DocIds": DocId,
    "ClientId": ClientId
  };

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(params),
  });

  return data.message.list;
}